import React from 'react';

import { HomePage } from 'components/features/home-page';
import { PageAnnouncer } from 'components/page-announcer';
import { PromoMessageRibbon } from 'pages/loyalty/loyalty-promo-message-ribbon';
import { t } from 'state/intl/translations';

const Home = () => {
  return (
    <>
      <PromoMessageRibbon skipStoreDayPartHours />
      <HomePage />
      <PageAnnouncer pageTitle={t('homepage')} />
    </>
  );
};

export default React.memo(Home);
